import { render } from "./component-payer-headline.vue?vue&type=template&id=517db939"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-payer-headline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "517db939"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('517db939', __exports__)) {
    api.reload('517db939', __exports__)
  }
  
  module.hot.accept("./component-payer-headline.vue?vue&type=template&id=517db939", () => {
    api.rerender('517db939', render)
  })

}


export default __exports__